import { baseUrl } from "../config";
import { EventBus } from "../eventbus";
import { errorDispatch } from "./errorDispatch";
import i18n from "./i18next";

export const copy = (vueThis, closeAllActions = false) => {
  //set items
  localStorage.setItem(
    vueThis.$store.state.company + "_" + "clipboard",
    JSON.stringify(vueThis.$store.state.transferItems)
  );

  //close all actions if needed
  if (closeAllActions) {
    EventBus.$emit("closeallactions");
  }

  //send snackbar
  EventBus.$emit(`snackbar--add`, {
    title: `${i18n.t("common.copied")}`,
    icon: "copy",
    timeout: 3000,
  });
};

export const copyItem = (vueThis, item) => {
  const clipboard = {};

  //clear current
  localStorage.setItem(vueThis.$store.state.company + "_" + "clipboard", "");

  if (item.extension) {
    clipboard.selectedFiles = [item];
    clipboard.selectedFolders = [];
  } else {
    clipboard.selectedFolders = [];
    clipboard.selectedFiles = [item];
  }

  localStorage.setItem(
    vueThis.$store.state.company + "_" + "clipboard",
    JSON.stringify(clipboard)
  );

  //send snackbar
  EventBus.$emit(`snackbar--add`, {
    title: `${item.name ? item.name : ""} ${i18n.t("common.copied")}`,
    icon: "copy",
    timeout: 3000,
  });
};

export const paste = (vueThis, folderId, closeAllActions = false) => {
  const clipBoadString = localStorage.getItem(
    vueThis.$store.state.company + "_clipboard"
  );
  const clipboard = clipBoadString !== "" ? JSON.parse(clipBoadString) : false;

  //const mySpace = vueThis.$route.path.includes("myspace") ? 1 : 0;

  if (!folderId) {
    folderId = vueThis.$route.params.id;
  }

  if (!clipboard) {
    //nothing to paste
    EventBus.$emit(`snackbar--add`, {
      title: `${i18n.t("common.nothing_to_paste")}`,
      icon: "paste",
      timeout: 3000,
    });
  }

  if (clipboard && folderId) {
    //clear clipboard for now
    localStorage.setItem(vueThis.$store.state.company + "_clipboard", "");

    const formData = new FormData();

    const files = clipboard.selectedFiles
      //.filter((file) => file.mySpace === mySpace)
      .map((file) => file.id);

    formData.append("files", JSON.stringify(files));

    const folders = clipboard.selectedFolders
      //.filter((folder) => folder.mySpace === mySpace)
      .map((folder) => folder.id);

    formData.append("folders", JSON.stringify(folders));
    formData.append("destination", folderId);

    return vueThis.$axios
      .post(baseUrl + "/paste", formData)
      .then(() => {
        EventBus.$emit(`snackbar--add`, {
          title: `${i18n.t("common.all_pasted")}`,
          timeout: 3000,
          icon: "checkmark--round",
          color: "#82b347",
        });

        if (closeAllActions) {
          EventBus.$emit("closeallactions");
        }

        if (vueThis.$route.params.id === folderId) {
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        }

        //clear copy
        localStorage.setItem(
          vueThis.$store.state.company + "_" + "clipboard",
          ""
        );
      })
      .catch(() => {
        errorDispatch("collect_paste");

        if (vueThis.$route.params.id === folderId) {
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        }

        //reset copy
        localStorage.setItem(
          vueThis.$store.state.company + "_" + "clipboard",
          JSON.stringify(clipboard)
        );
      });
  }

  return false;
};
